import { render, staticRenderFns } from "./BulletListComponent.vue?vue&type=template&id=ae0ef19c"
import script from "./BulletListComponent.vue?vue&type=script&lang=js"
export * from "./BulletListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports